import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      {/* 데스크톱 전용 */}
      <div className="footer-desktop only-desktop">
        <div className="footer-info">
          <p>주소: 서울특별시 송파구 백제고분로 216 청송빌딩 6층 (주)에버영피플</p>
          <p>대표이사: 이한복 &nbsp;&nbsp; 사업자등록번호: 320-86-00820</p>
          <p>이메일 문의: recruit@everyoungpeople.com</p>
        </div>
        <div className="footer-copy">
          <p>Copyright Everyoung People Corp. All Rights Reserved.</p>
        </div>
      </div>

      {/* 모바일 전용 */}
      <div className="footer-mobile only-mobile">
        <div className="footer-info">
          <p>주소: 서울 송파구 백제고분로 216<br />청송빌딩 6층 (주)에버영피플</p>
          <p>대표: 이한복<br />사업자등록번호: 320-86-00820</p>
          <p>이메일: recruit@everyoungpeople.com</p>
        </div>
        <div className="footer-copy">
          <p>Copyright Everyoung People Corp. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

